import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import BasePage from "./BasePage";
import PageLayout from "./layout";
import AuthPage from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Portal from "./pages/Portal";
import { needsOnboarding } from "./utils/onboardingGate";

const Routes = () => {
  const { isAuthorized, organization, portalCustomer } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.isAuthenticated,
      organization: auth.organization,
      portalCustomer: auth.portalCustomer,
    }),
    shallowEqual
  );

  if (!isAuthorized) {
    return <AuthPage />;
  }

  /* یک نفر یا در پنل است یا در پرتال، هیچ‌وقت هر دو: مشتری عضو سازمان نیست و
   * سایدبار پنل برایش جای رفتن ندارد. تعویض بین این دو از سوییچر فضای کاری
   * انجام می‌شود، نه از صفحه‌ی ورود. */
  if (portalCustomer) {
    return (
      <PageLayout>
        <Portal />
      </PageLayout>
    );
  }

  /* A workspace that has never finished setup gets the wizard instead of the
   * panel — no sidebar to wander into and nothing to dismiss, which is the whole
   * point of it being a gate rather than a prompt. */
  if (needsOnboarding(organization)) {
    return <Onboarding />;
  }

  return (
    <PageLayout>
      <BasePage />
    </PageLayout>
  );
};

export default Routes;
